import { unMaskCurrency } from '@utils/masks/unMaskCurrency'

import { getDay } from './getDay'
import { getDate } from './getDate'

import type { CreateNewServiceRequestProps } from '@services/api/invoicing/clients/types'
import type { AddEditServiceModalFormProps } from '../components/AddEditServiceModal/form/types'

export const parseCreateNewServicePayload = (formData: AddEditServiceModalFormProps) => {
  const startBillingDate = formData.startBillingDate || ''

  const payload: CreateNewServiceRequestProps = {
    serviceId: formData.serviceId || null,
    filiCodigo: formData.filiCode || '',
    cdClienteNl: formData.cdClientCode || '',
    startBillingDate,
    desClienteNl: formData.descClientName || '',
    desTipoCliente: formData.clientType || '',
    fatDtCompetencia: formData.fatCompetenceDate || '',
    agrupamentoServico: formData.grouping || '',
    cdItemVenda: formData.descriptionId?.toString() || '',
    nmItemVenda: formData.descriptionName || '',
    periodoInicio: startBillingDate,
    periodoFim: formData.endPeriod || '',
    diaFaturamento: formData.billingDay || '',
    vlBrutoUnitario: formData.grossUnitValue ? Number(formData.grossUnitValue) : 0,
    qtFaturadaPrevia: formData.totalQuantity ? Number(formData.totalQuantity) : 0,
    vlTotalBrutoPrevia: formData.grossTotal ? unMaskCurrency(formData.grossTotal) : 0,
    vlTotalLiquidaPrevia: formData.netTotal ? unMaskCurrency(formData.netTotal) : 0,
    contcVlrlFatPerimposto: formData.tax ? Number(formData.tax.toString().replace(',', '.')) : 0,
    valorDias: !!formData.days?.length
      ? formData.days.map((day) => ({
          data: getDate(day.label),
          dia: getDay(day.label),
          valor: Number(day.value)
        }))
      : [],
    ...(formData.previewNumber !== undefined && { previewNumber: formData.previewNumber })
  }

  return payload
}
